document.addEventListener('DOMContentLoaded', () => {
    // ✅ Swiper initialization
    new Swiper(".board-members-slider", {
      slidesPerView: 1.5,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  
    // ✅ Section toggle logic
    const links = document.querySelectorAll('a[href^="#section-"]');
    const sections = document.querySelectorAll('section[id^="section-"]');
  
    links.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
  
        const targetLink = e.currentTarget;
        const targetId = targetLink.getAttribute('href').replace('#', '');
        const targetSection = document.getElementById(targetId);
  
        // ❌ Hide all sections
        sections.forEach((section) => {
          section.style.display = 'none';
        });
  
        // ❌ Remove active class from all links
        links.forEach((l) => l.classList.remove('sidebar-link-active'));
  
        // ✅ Add active class to the clicked link
        targetLink.classList.add('sidebar-link-active');
  
        // ✅ Show target section
        if (targetSection) {
          targetSection.style.display = 'block';
          targetSection.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  
    // ✅ Initial setup: show first section and highlight first link
    if (sections.length > 0) {
      sections.forEach((section, index) => {
        section.style.display = index === 0 ? 'block' : 'none';
      });
    }
  
    if (links.length > 0) {
      links[0].classList.add('sidebar-link-active');
    }
  });
  